import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';
export const Section = styled.div`
  background: ${(props) =>
    props.color || props.primary ? 'var(--cvna-color-grey-1)' : 'var(--cvna-color-white)'};
  min-height: 30rem;
  color: ${(props) =>
    props.color || props.primary ? 'var(--cvna-color-blue-6)' : 'var(--cvna-color-grey-5)'};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding-top: 2rem;

  ${mediaQuery('m')} {
    padding-top: 4.875rem;
  }
`;

export const InnerSection = styled.div`
  padding: 3rem 0 4rem;
  margin: 0 auto;
  max-width: 1440px;
  width: 93%;

  ${mediaQuery('s')} {
    width: 91%;
  }

  ${mediaQuery('l')} {
    width: 80%;
  }

  ${mediaQuery('xl')} {
    width: 1006px;
  }
`;
